import {Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy} from '@angular/core';
import {HROUTES} from './navigation-routes.config';
import {LayoutService} from '../services/layout.service';
import {ConfigService} from '../services/config.service';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {ROUTES} from '../vertical-menu/vertical-menu-routes.config';
import {RouteInfo} from '../vertical-menu/vertical-menu.metadata';
import {PermissionManagerService} from '../services/permission-manager.service';
import {AuthenticationService} from '../services/authentication.service';
import * as swalFunctions from '../data/sweet-alert';


@Component({
  selector: 'app-horizontal-menu',
  templateUrl: './horizontal-menu.component.html',
  styleUrls: ['./horizontal-menu.component.scss']
})
export class HorizontalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  public menuItems: any[];
  public config: any = {};
  level: number = 0;
  transparentBGClass = '';
  menuPosition = 'Side';

  layoutSub: Subscription;
  mostrarMenu = false;
  swal = swalFunctions;

  constructor(private layoutService: LayoutService,
              private configService: ConfigService,
              private cdr: ChangeDetectorRef,
              private router: Router,
              private permissionManagerService: PermissionManagerService,
              private auth: AuthenticationService) {
    this.config = this.configService.templateConf;
  }

  ngOnInit() {
    this.menuItems = HROUTES;
    const menuItems: RouteInfo[] = [];
    for (const menu of HROUTES) {
      if (menu.idcontro !== 0 && this.permissionManagerService.isGranted(menu.idcontro)) {
        const submen: RouteInfo[] = []
        for (const submenu of menu.submenu) {
          if (submenu.idcontro !== 0 && this.permissionManagerService.isGranted(submenu.idcontro)) {
            submen.push(submenu);
            this.cdr.detectChanges();
          }
        }
        if (menu.submenu.length === 0 || submen.length > 0) {
          menu.submenu = submen;
          menuItems.push(menu)
          this.cdr.detectChanges();
        }
      } else if (menu.idcontro === 0) {
        if (this.permissionManagerService.authenticationService.isUsuarioEspecial()) {
          menuItems.push(menu);
          this.cdr.detectChanges();
        }
      }
    }
    this.menuItems = menuItems;

    if (this.auth.cambioContrasena() < 13) {
      this.mostrarMenu = true;
    } else {
      this.router.navigate(['administracion/perfil-usuario']);
    }

    this.cdr.detectChanges();
  }

  ngAfterViewInit() {

    this.layoutSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    })
  }

  loadLayout() {

    if (this.config.layout.menuPosition && this.config.layout.menuPosition.toString().trim() != '') {
      this.menuPosition = this.config.layout.menuPosition;
    }


    if (this.config.layout.variant === 'Transparent') {
      this.transparentBGClass = this.config.layout.sidebar.backgroundColor;
    } else {
      this.transparentBGClass = '';
    }

  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }

}
